import React from "react"
import Transition from "../components/layout/Transition"

const Layout = (props) => (
	<Transition location={props.location}>
		{props.children}
	</Transition>
);

export default Layout;